import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

function useStripSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const weatherStripColor = useStore((state) => state.quote.weatherStripColor);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);
  const material = useStore((state) => state.quote.material);

  const isAlum = material === "All Aluminum";

  const handleClick = (label: string) => {
    const checked = checkMark(label);

    addToQuote(
      {
        weatherStripColor: !checked ? label : "",
      },
      "weatherStripColor"
    );

    if (!checked && findRequired("Weather Strip Color"))
      removeRequired("Weather Strip Color");
  };

  const variant = (label: string) =>
    label === weatherStripColor ? "filled" : "outlined";

  const checkMark = (label: string) => label === weatherStripColor;

  return {
    checkMark,
    variant,
    handleClick,
    isAlum,
  };
}

export default useStripSelector;
